module.exports = __webpack_public_path__ + "static/media/cinema.ec7ff4df.jpg";